<template>
  <div class="wrapper">
    <div class="main">
      <div class="section">
        <div class="container">
          <md-card class="bar-breadcrumb">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item">
                  <span>{{ $t("主页") }}</span>
                </div>
              </div>
            </md-card-content>
          </md-card>

          <div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "cart_share_apply",
  bodyClass: "cart_share_apply-page",
  props: {},
  data() {
    return {
      product: {},
    };
  },
  methods: {

    async cartApplyShare() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "cart_share_apply.php",
        data: {
          share_token : this.$route.params.share_token,
          member_id: this.$store.state.member_id
        }
      });
      this.loader.hide();
      this.$router.replace({ name: "cart", params: {} });
    },
  },
  computed: {},
  async created() {
    await this.cartApplyShare();
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  beforeDestroy() {}
};
</script>
<style lang="scss">
</style>